module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, _vm._l((_vm.dataList), function(item, index) {
    return (!_vm.loading) ? _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('div', [_vm._v("凭证号: " + _vm._s(item.INSURANCE_NO))]), _vm._v(" "), _c('div', [_vm._v("补偿科目: " + _vm._s(item.CLAIM_CLASS_NAME))]), _vm._v(" "), _c('div', [_vm._v("补偿金额(元): " + _vm._s(item.CLAIM_FEE))]), _vm._v(" "), _c('div', [_vm._v("挂科时间: " + _vm._s(item.CLAIM_TIME))]), _vm._v(" "), _c('div', [_vm._v("申请日期: " + _vm._s(_vm.formatDate(item.CREATE_TIME)))]), _vm._v(" "), _c('div', [_vm._v("处理日期: " + _vm._s(_vm.formatDate(item.UPDATE_TIME)))]), _vm._v(" "), _c('div', [_vm._v("补偿状态:\n          "), _vm._v(" "), (item.CLAIM_STATUS == '0') ? _c('van-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '6') ? _c('van-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '1') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("资料收集成功，案件复核中")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '2') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("补偿中")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '3') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("打款成功")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '7') ? _c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v("审核驳回")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '9') ? _c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v("审核拒绝")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '12') ? _c('van-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v("打款失败")]) : _vm._e(), _vm._v(" "), (item.CLAIM_STATUS == '20') ? _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v("已报案")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm._v("备注: " + _vm._s(item.CLAIM_STATUS == '1' ? "资料初审已通过，待复核通过后打款" : item.CLAIM_REFUSE))]), _vm._v(" "), (item.jjid != '' && item.jjid != null) ? _c('div', [_vm._v("加急状态: "), _c('van-tag', {
      attrs: {
        "type": "success"
      }
    }, [_vm._v(_vm._s(item.jjlx))])], 1) : _vm._e(), _vm._v(" "), ((item.CLAIM_STATUS == '1') && (item.jjid == '' || item.jjid == null) && _vm.isDict == 1) ? _c('div', [_c('van-button', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "size": "large",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.openFormEvent(item)
        }
      }
    }, [_vm._v("加急")])], 1) : _vm._e()]), _vm._v(" "), _c('van-popup', {
      style: ({
        height: '50%'
      }),
      attrs: {
        "position": "bottom",
        "close-on-click-overlay": false
      },
      model: {
        value: (_vm.openForm),
        callback: function($$v) {
          _vm.openForm = $$v
        },
        expression: "openForm"
      }
    }, [_c('van-form', [_c('van-field', {
      attrs: {
        "value": _vm.jjType,
        "name": "加急类型",
        "label": "加急类型",
        "readonly": "",
        "clickable": "",
        "placeholder": "请输入选择加急类型"
      },
      on: {
        "click": function($event) {
          _vm.showPicker = true
        }
      }
    }), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.showPicker),
        callback: function($$v) {
          _vm.showPicker = $$v
        },
        expression: "showPicker"
      }
    }, [_c('van-picker', {
      attrs: {
        "show-toolbar": "",
        "columns": _vm.sysDictList,
        "value-key": "dictName"
      },
      on: {
        "cancel": function($event) {
          _vm.showPicker = false
        },
        "confirm": _vm.onConfirm
      }
    })], 1), _vm._v(" "), _c('van-field', {
      attrs: {
        "value": _vm.jjbj,
        "name": "加急比例(%)",
        "label": "加急比例(%)",
        "readonly": ""
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "value": _vm.jjje,
        "name": "服务费(元)",
        "label": "服务费(元)",
        "readonly": ""
      }
    }), _vm._v(" "), _c('van-field', {
      attrs: {
        "value": _vm.paymentValue,
        "name": "支付方式",
        "label": "支付方式",
        "readonly": "",
        "clickable": "",
        "placeholder": "请输入选择加急类型"
      },
      on: {
        "click": function($event) {
          _vm.paymentTypeOpen = true
        }
      }
    }), _vm._v(" "), _c('van-popup', {
      attrs: {
        "position": "bottom"
      },
      model: {
        value: (_vm.paymentTypeOpen),
        callback: function($$v) {
          _vm.paymentTypeOpen = $$v
        },
        expression: "paymentTypeOpen"
      }
    }, [_c('van-picker', {
      attrs: {
        "show-toolbar": "",
        "columns": [{
            name: '支付宝',
            value: 'ALP'
          },
          {
            name: '微信',
            value: 'WXP'
          }
        ],
        "value-key": "name"
      },
      on: {
        "cancel": function($event) {
          _vm.paymentTypeOpen = false
        },
        "confirm": _vm.paymentBtn
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sign"
    }, [_c('a', {
      staticClass: "btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": _vm.gotoSign
      }
    }, [_vm._v(" 手写签名")])]), _vm._v(" "), _c('p', {
      staticClass: "protocol"
    }, [_c('van-checkbox', {
      attrs: {
        "icon-size": "18px"
      },
      on: {
        "change": _vm.readBook
      },
      model: {
        value: (_vm.checked),
        callback: function($$v) {
          _vm.checked = $$v
        },
        expression: "checked"
      }
    }, [_vm._v("同意\n            ")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "16px",
        "display": "flex"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "30%",
        "margin": "0px 10%"
      },
      attrs: {
        "round": "",
        "block": "",
        "type": "info"
      },
      on: {
        "click": _vm.closePop
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('van-button', {
      staticStyle: {
        "width": "30%",
        "margin": "0px 10%"
      },
      attrs: {
        "round": "",
        "block": "",
        "type": "primary"
      },
      on: {
        "click": _vm.saveInfo
      }
    }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _c('van-dialog', {
      style: ({
        top: _vm.isPhone ? '50%' : ''
      }),
      attrs: {
        "title": "手写签名",
        "show-cancel-button": false,
        "showConfirmButton": false,
        "width": _vm.isPhone ? '100%' : '900px'
      },
      model: {
        value: (_vm.signShow),
        callback: function($$v) {
          _vm.signShow = $$v
        },
        expression: "signShow"
      }
    }, [_c('signer', {
      on: {
        "set-sign": _vm.setSign
      }
    })], 1), _vm._v(" "), (_vm.openImg) ? _c('van-dialog', {
      attrs: {
        "title": ("请使用" + _vm.openImgTitle + "扫码支付"),
        "show-cancel-button": ""
      },
      model: {
        value: (_vm.openImg),
        callback: function($$v) {
          _vm.openImg = $$v
        },
        expression: "openImg"
      }
    }, [(_vm.openImg) ? _c('van-image', {
      staticStyle: {
        "width": "80%",
        "margin": "20px 10% 20px 10%"
      },
      attrs: {
        "src": _vm.paymentUrl
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86ca97ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/myInfo.vue
// module id = 486
// module chunks = 1